import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/products', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/products', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/products/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/products/${data.product_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/products/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const getBarcode = (category_id, Options = {}) => {
  return httpClient
    .get(`/api/products/barcodes/${category_id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSaleCode = (Options = {}) => {
  return httpClient
    .get('/api/products/sale-code-lists', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getCategory = (Options = {}) => {
  return httpClient
    .get('/api/products/categories', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getUOMC = (Options = {}) => {
  return httpClient
    .get('/api/products/uom-categories', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const copyPrice = data => {
  return httpClient
    .post('/api/products/copy-prices', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const exportProductPrice = data => {
  return httpClient
    .post('/api/products/export-product-prices', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const setInactive = id => {
  return httpClient
    .get(`/api/products/${id}/inactive`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSupplier = (Options = {}) => {
  return httpClient
    .get('/api/products/suppliers', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  getBarcode,
  getSaleCode,
  getCategory,
  getUOMC,
  copyPrice,
  exportProductPrice,
  getSupplier,
  setInactive
}
